import { html, LitElement, css } from 'lit'

import { type Assignable, isUser } from '../../shared/domain/schedule/assignee.no-deps'
import { customElement, property } from 'lit/decorators.js'

@customElement('zaptic-assignable-icon')
export class AssignableIcon extends LitElement {
    static styles = css`
        zaptic-profile-circle {
            --ProfileCircle-size: var(--ProfileCircle-size-override, 39px);
        }

        .zaptic-assignable-team-icon {
            display: flex;    
            width: var(--TeamCircle-size-override, 32px);
            height: var(--TeamCircle-size-override, 32px);]

        }
    `

    @property({ type: Object })
    assignee: Assignable

    render() {
        if (this.assignee == null) return html``

        return html`
            ${isUser(this.assignee)
                ? html`
                      <zaptic-profile-circle
                          name=${this.assignee.name}
                          color=${this.assignee.profileCircleColor}
                          profile-image-url=${this.assignee.profileImageUrl}
                      ></zaptic-profile-circle>
                  `
                : html`
                      <svg class="zaptic-assignable-team-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                          <g fill="none" fill-rule="evenodd">
                              <circle cx="17.5" cy="17.5" r="17.5" fill="#DCEEF9" />
                              <g fill="#4F5B68">
                                  <path
                                      d="M4.222 0C2.67 0 1.407 1.221 1.407 2.722S2.67 5.444 4.222 5.444s2.815-1.22 2.815-2.722C7.037 1.222 5.774 0 4.222 0zM10.905 0h-.02c-.663.005-1.283.261-1.745.721-.454.452-.701 1.049-.695 1.68.005.63.263 1.223.725 1.668.466.449 1.083.695 1.74.695h.019c.664-.005 1.284-.261 1.746-.722.454-.452.701-1.048.695-1.679C13.358 1.056 12.255 0 10.905 0zM10.7 5.444h-.226c-1.05 0-2.01.385-2.733 1.016.18.134.353.28.517.437.482.464.86 1.005 1.125 1.608.238.543.374 1.114.406 1.703h4.989v-.836c0-2.166-1.83-3.928-4.078-3.928zM9.14 10.115c-.084-1.289-.765-2.422-1.78-3.149-.74-.528-1.656-.841-2.648-.841h-.275C1.987 6.125 0 8.032 0 10.383v.506h9.148v-.506c0-.09-.003-.18-.009-.268z"
                                      transform="translate(9.81 12.75)"
                                  />
                              </g>
                          </g>
                      </svg>
                  `}
        `
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'zaptic-assignable-icon': AssignableIcon
    }
}
